import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

// Pagina permanente «La vostra attività»: numeri dell'account per
// l'albergatore. Solo lettura, quindi niente KeepAlive: si ricarica a ogni
// apertura (la cache di un'ora vive lato server).
const ADMIN_ROLES = ['administrator'];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/analytics'),
      roles: ADMIN_ROLES,
      component: SettingsContent,
      props: {
        headerTitle: 'SETTINGS_CENTER.ACTIVITY',
        icon: 'arrow-trending-lines',
        keepAlive: false,
      },
      children: [
        {
          path: '',
          name: 'settings_analytics',
          component: Index,
          roles: ADMIN_ROLES,
        },
      ],
    },
  ],
};
